import cart from '@ppcp/cart';
import {getSetting} from '@ppcp/utils';
import {CartController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import GooglePayGateway from '../gateways/GooglePayGateway';

const settings = getSetting('ppcp_googlepay_data');
const {disabled = false} = settings;

if (!disabled) {
    const gateway = new GooglePayGateway({
        id: 'ppcp_googlepay',
        cart,
        settings
    });

    const context = new Context('cart');

    const controller = new CartController({
        id: 'ppcp_googlepay',
        cart,
        context,
        gateway,
        settings
    });

    controller.initialize();
}